module.exports = __webpack_public_path__ + "static/img/1772_phase_function_Paper_Points.66158ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1772_phase_function_Paper_Points.png
// module id = usPV
// module chunks = 0